import { writable } from 'svelte/store';
export const emptyTraining = {
    id: 0,
    id_partner: 0,
    title_fr: "",
    title_en: "",
    description_fr: "",
    description_en: "",
    date_training: "",
    url_training: "",
};
export const storeTrainings = writable([]);
export const storeTrainingsError = writable("");
export const storeTraining = writable(emptyTraining);
